// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import 'typeface-poppins';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import 'material-icons/iconfont/material-icons.css';
// import "primereact/resources/themes/lara-light-indigo/theme.css"; 
import "./styles/primereact.css";    
import "primereact/resources/primereact.min.css";
import PrimeReact from 'primereact/api';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import './i18n'; //needs to be imported after app
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();

// Default values
PrimeReact.zIndex = {
   modal: 1100,
   overlay: 10000,
   menu: 1000,
   tooltip: 1100,
   toast: 1200
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
